<template>
    <v-card>
      <v-toolbar
        dark
        color="primary"
        flat
      >
        <v-toolbar-title>Modifica pratica</v-toolbar-title>
      </v-toolbar>
      <moduleStructure :id="$route.params.id" :token="$route.params.token" edit-mode />
    </v-card>
  </template>
  <script>
  import moduleStructure from './components/moduleStructureBeneficiary'
  export default {
    components: { moduleStructure },
  };
  </script>
  